import get from 'lodash.get';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import apiUtil from 'src/api/businessOnboarding';
import Loader from 'src/components/Loader';
import { AppContext } from 'src/containers/Core/AppContext';
import { AppState, setBusinessOnboardingDetails } from 'src/containers/Core/AppReducer';
import { addPusherEventListener, Channels, Events, getChannelName, subscribe, unsubscribe } from 'src/utils/pusher';
import { BUSINESS_ONBOARDING_STEP } from '..';
import { Slide1 } from './Images';

type JoinCommunitySubmitProps = {};

const JoinCommunitySubmit: React.FunctionComponent<JoinCommunitySubmitProps> = () => {
  const { store, dispatch } = useContext(AppContext);
  const { businessOnboardingDetails, user }: AppState = store;
  const [approvalDetails, setApprovalDetails] = useState<{
    isApproved: boolean;
    community: string;
  }>(null);
  const [loading, setLoading] = useState(false);

  const step: BUSINESS_ONBOARDING_STEP = businessOnboardingDetails && businessOnboardingDetails.step;
  const businessUuid: string = get(businessOnboardingDetails, 'business.uuid');

  if (!businessUuid) {
    return null;
  }

  const getApprovalStatus = async () => {
    try {
      setLoading(true);
      const response = await apiUtil.getOnboardingApporval(businessUuid);
      setApprovalDetails({
        isApproved: !!get(response, 'isApproved'),
        community: get(response, 'community.name', ''),
      });
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getApprovalStatus();
  }, []);

  useEffect(() => {
    if (businessUuid && user) {
      const channelName: string = getChannelName(Channels.MY_ENTITY, businessUuid, user.uuid);
      const myBusinessPusherChannel = subscribe(channelName);
      addPusherEventListener(myBusinessPusherChannel, Events.ONBOARDING, '', async () => {
        getApprovalStatus();
        const response: BusinessOnboardingDetails[] = await apiUtil.getBusinessOnboarding();
        if (Array.isArray(response)) {
          dispatch(setBusinessOnboardingDetails(response[0]));
        }
      });
    }

    return () => {
      unsubscribe(getChannelName(Channels.MY_ENTITY, businessUuid, user.uuid));
    };
  }, [user, businessUuid]);

  const getTitleAndMessage = () => {
    let title;
    let message;

    if (get(approvalDetails, 'isApproved')) {
      title = `You have successfully onboarded ${get(
        businessOnboardingDetails,
        'business.name'
      )} on Open Rewards as part of ${get(approvalDetails, 'community')} Community.`;
      message = 'You have successfully completed onboarding process.';
    } else {
      if (step === BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_WAITLIST) {
        title =
          // tslint:disable-next-line:max-line-length
          'Your community can be live as soon as 20 businesses sign up – help spread the word and gather your fellow local businesses to join!';
        message =
          // tslint:disable-next-line:max-line-length
          'You will be able to check your rewards and manage your balance on the app - coming soon on the App Store and Google Play.';
      } else {
        title = `We have sent your request to ${get(approvalDetails, 'community')} community for approval.`;
        message =
          // tslint:disable-next-line:max-line-length
          'You will be able to check your rewards and manage your balance on the app - coming soon on the App Store and Google Play.';
      }
    }

    return {
      title,
      message,
    };
  };

  if (loading || !approvalDetails) {
    return <Loader />;
  }

  return (
    <Row className="h-100 d-flex justify-content-center align-items-center">
      <Col sm={12} md={5} className="content d-flex flex-column align-items-center text-center">
        <div className="d-flex justify-content-center align-items-center">
          <Slide1 />
        </div>
        <h5 className="my-3">{getTitleAndMessage().title}</h5>
        <span className="medium text-muted mb-5">{getTitleAndMessage().message}</span>
      </Col>
    </Row>
  );
};

export default JoinCommunitySubmit;
